import ApiService from './ApiService';

export default {
    find(creds){
        return ApiService.post('/timing/find', creds);
    },
    update(creds){
        return ApiService.post('/timing/update', creds);
    }
}